import { useThree } from '@react-three/fiber';
import { useMemo } from 'react';
import { PerspectiveCamera } from 'three';

const useSphereRadius = (distance: number, screenFraction = 0.5) => {
  const { camera, size } = useThree();

  return useMemo(() => {
    if (!camera || !size) return 0;

    const verticalFovInRadians =
      ((camera as PerspectiveCamera).fov * Math.PI) / 180;

    const visibleHeight = 2 * distance * Math.tan(verticalFovInRadians / 2);
    const visibleWidth = (visibleHeight * size.width) / size.height;

    return (screenFraction * visibleWidth) / 2;
  }, [camera, size, distance, screenFraction]);
};

export default useSphereRadius;
